import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _path, _path2;
var _excluded = ["className", "size"];
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AlertCircle = function AlertCircle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-fill-current' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, rest), {}, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      d: "M12 7a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1ZM12 15a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      className: "tw-fill-current",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
    }))]
  }));
};